// IE 2026 10 08 / ODOO-341407 (Igor 08.10, скрины «Signals» на dev02: «Название в настройках … не на языке пользователя хотя в отчёте … все правильно»):
// НАЗВАНИЕ ПОЛЯ СТРОКИ РАСКЛАДКИ DL2 (doc.params.data_layout2[…].fields / values) в настройках отчёта — по тому же правилу, что подпись колонки готового отчёта.
// Как подписывает отчёт (бэк): колонка = само поле строки раскладки (create_childs: node['fields-tree']), подпись — attrs.localize_attrs → _i18n_apply
// (common_modules/attrs.py): непустой title_{lang} поля (перевод / своё название пользователя) → словарь бэка attrs.t(title, lang, ctx) (ключ 'title|ctx'
// раньше 'title'; нет в словаре — title как есть); под en — словарь en.json только для title с кириллицей. Запись раскладки бэк НЕ локализует
// (attrs.localize_record_rows: «Раскладка REPORT2 (doc.data_layout2) не трогается»), поэтому чипсы колонок «Fields» / «Values» грида раскладки и
// колонка «Title» грида полей строки показывали английскую базу. Здесь — только ПОКАЗ: запись, база title и переводы не меняются.
// Словарь — тот же, что у бэка (команда i18n_dict_get → attrs.i18n_dict; на фронте i18n/relocalize.dictGet: память → IndexedDB по etag → бэк), грузится
// лениво (загрузчик передаёт вызывающий), до загрузки показывается база — как раньше. Чистая логика без Vue (юнит — tests/unit/dl2FieldTitle.test.mjs).
// Выключатель fe.i18n.dl2SettingsTitles (реестр feSettings, по умолчанию ВКЛ; выкл — как до правки): AttrGrid.dl2Titles_on.

export const FLAG_DL2_SETTINGS_TITLES = 'fe.i18n.dl2SettingsTitles'
export const DL2_LANG_DEFAULT = 'en'
const CYR_RE = /[А-Яа-яЁёІіЇїЄєҐґ]/
// контекст словаря — зеркало бэка attrs.i18n_ctx (и фронта relocalize._ctxOf)
const CTX_KEY = 'i18n_ctx'
const CTX_GRID_BINDINGS = ['frozenColumns', 'frozenRows', 'frozenColumns_auto']
const CTX_TAB_BINDINGS = { ORDER: 'sort', query: 'sql' }

// путь в записи-владельце — поля / меры строки раскладки DL2: 'doc.params.data_layout2' (+ путь строки) + последний сегмент fields | values.
// Сквозной список колонок doc.params.data_layout2_fields и прочие гриды — нет
export function dl2_isFieldsPath(path) {
    const p = String(path || '')
    return /^doc\.params\.data_layout2(?=$|[.[])/.test(p) && /(^|[.\]])(fields|values)$/.test(p)
}

export function dl2_ctxOf(field) {
    if (!field || typeof field !== 'object') return ''
    const c = field[CTX_KEY]
    if (typeof c === 'string') return c
    if (!Array.isArray(field.attrs)) return ''
    const tails = field.attrs.filter(k => k && typeof k === 'object').map(k => String(k.binding || '').split('.').pop())
    if (tails.some(t => CTX_GRID_BINDINGS.includes(t))) return 'grid'
    if (field.attr_type === 'AttrTab') {
        for (const t of tails) if (Object.prototype.hasOwnProperty.call(CTX_TAB_BINDINGS, t)) return CTX_TAB_BINDINGS[t]
    }
    return ''
}

// t бэка (attrs.t) по словарю dict языка lang: 'text|ctx' раньше 'text'; массив форм → первая; en — только текст с кириллицей; нет — text
export function dl2_dictT(dict, lang) {
    const d = (dict && typeof dict === 'object') ? dict : {}
    const L = lang || DL2_LANG_DEFAULT
    return (text, ctx) => {
        if (typeof text !== 'string' || !text) return text
        if (L === DL2_LANG_DEFAULT && !CYR_RE.test(text)) return text
        let v = ctx ? d[`${text}|${ctx}`] : undefined
        if (v === undefined || v === null) v = d[text]
        if (Array.isArray(v)) v = v[0]
        return (typeof v === 'string' && v) ? v : text
    }
}

// своё название поля на языке lang (title_{lang}; у en суффикса нет — title_en у переведённых объектов служебный бэкап)
function _own(field, L) {
    if (L === DL2_LANG_DEFAULT) return ''
    const v = field['title_' + L]
    return (typeof v === 'string' && v) ? v : ''
}

// нужен ли словарь бэка, чтобы показать название поля на языке lang (своего перевода нет; под en — только кириллическая база)
export function dl2_needsDict(field, lang) {
    if (!field || typeof field !== 'object') return false
    const L = lang || DL2_LANG_DEFAULT
    if (_own(field, L)) return false
    const base = field.title
    if (typeof base !== 'string' || !base) return false
    return L !== DL2_LANG_DEFAULT || CYR_RE.test(base)
}

// показанное название поля на языке lang ('' — названия нет: показ как раньше, по колонке-подписи). T — t бэка (dl2_dictT) или null: словарь ещё
// не загружен — база title, как до правки
export function dl2_fieldTitle(field, lang, T) {
    if (!field || typeof field !== 'object') return ''
    const L = lang || DL2_LANG_DEFAULT
    const own = _own(field, L)
    if (own) return own
    const base = field.title
    if (typeof base !== 'string' || !base) return ''
    if (typeof T !== 'function' || (L === DL2_LANG_DEFAULT && !CYR_RE.test(base))) return base   // под en словарь — только для кириллицы (как attrs.t)
    const v = T(base, dl2_ctxOf(field))
    return (typeof v === 'string' && v) ? v : base
}

// ---- словари бэка по языкам: ленивая загрузка одним запросом на язык за сеанс (общий промис), неудача — повтор не раньше чем через минуту ----
const _dicts = {}
const _loading = {}
const _failed = {}
const RETRY_MS = 60000

// словарь языка, если уже загружен; иначе null и (есть load) загрузка в фоне: load(lang) → Promise<{ dict }> (relocalize.dictGet). onReady(lang, ok) —
// по окончании загрузки (ok — словарь есть: вызывающий перерисовывается); зовётся один раз на вызов — повторно вызывающий не подписывается сам
export function dl2_dict(lang, load, onReady) {
    const L = lang || DL2_LANG_DEFAULT
    if (_dicts[L]) return _dicts[L]
    if (typeof load !== 'function') return null
    if (_failed[L] && Date.now() - _failed[L] < RETRY_MS) { if (typeof onReady === 'function') onReady(L, false); return null }
    if (!_loading[L]) {
        _loading[L] = Promise.resolve()
            .then(() => load(L))
            .then((entry) => {
                const d = entry && entry.dict
                if (d && typeof d === 'object') { _dicts[L] = d; delete _failed[L] } else _failed[L] = Date.now()
            }, () => { _failed[L] = Date.now() })
            .finally(() => { delete _loading[L] })
    }
    if (typeof onReady === 'function') _loading[L].then(() => onReady(L, !!_dicts[L]))
    return null
}

// служебное (юнит / пробы): положить словарь языка / сбросить всё
export function dl2_dictSet(lang, dict) { _dicts[lang || DL2_LANG_DEFAULT] = dict }
export function dl2_dictReset() { for (const o of [_dicts, _loading, _failed]) for (const k of Object.keys(o)) delete o[k] }
